import { Box, Chip, Typography } from "@mui/material";
import type { LogislyOrderTakerConfigV2 } from "../../types/logislyOrderTakerV2";

interface LogislyOrderTakerV2RouteProps {
  config: Pick<LogislyOrderTakerConfigV2, "muat" | "bongkar" | "isMultidrop">;
}

const LogislyOrderTakerV2Route = ({ config }: LogislyOrderTakerV2RouteProps) => {
  const destinations = [...config.bongkar].sort((a, b) => (a.priority ?? 0) - (b.priority ?? 0));

  return (
    <Box
      sx={{ display: "flex", alignItems: "center", flexWrap: "wrap", columnGap: 0.5, rowGap: 0.25 }}
    >
      <Typography variant="body2">{config.muat.name}</Typography>
      <Typography variant="body2" component="span">
        {config.isMultidrop ? "→ ... →" : "→"}
      </Typography>
      {destinations.map((location, index) => (
        <Box
          key={location.logislyLocationId}
          sx={{ display: "inline-flex", alignItems: "center", gap: 0.5 }}
        >
          {index > 0 && (
            <Chip
              size="small"
              label="OR"
              sx={{ height: 16, "& .MuiChip-label": { px: 0.5, fontSize: "0.625rem" } }}
            />
          )}
          <Typography variant="body2">{location.name}</Typography>
        </Box>
      ))}
    </Box>
  );
};

export default LogislyOrderTakerV2Route;
